/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandStrava = createReactComponent("outline", "brand-strava", "IconBrandStrava", [["path", { "d": "M15 13l-5 -10l-5 10m6 0l4 8l4 -8", "key": "svg-0" }]]);

export { IconBrandStrava as default };
//# sourceMappingURL=IconBrandStrava.mjs.map
